var _rect, _rect2, _rect3, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHettiLogoCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 252,
    viewBox: "0 0 252 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 116,
    width: 45,
    height: 20,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 56,
    width: 20,
    height: 144,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 56,
    width: 20,
    height: 144,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249 126C249 193.931 193.931 249 126 249V251C195.036 251 251 195.036 251 126H249ZM126 3C193.931 3 249 58.069 249 126H251C251 56.9644 195.036 1 126 1V3ZM3 126C3 58.069 58.069 3 126 3V1C56.9644 1 1 56.9644 1 126H3ZM126 249C58.069 249 3 193.931 3 126H1C1 195.036 56.9644 251 126 251V249ZM250 126C250 194.483 194.483 250 126 250V252C195.588 252 252 195.588 252 126H250ZM126 2C194.483 2 250 57.5167 250 126H252C252 56.4121 195.588 0 126 0V2ZM2 126C2 57.5167 57.5167 2 126 2V0C56.4121 0 0 56.4121 0 126H2ZM126 250C57.5167 250 2 194.483 2 126H0C0 195.588 56.4121 252 126 252V250Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHettiLogoCircle);
export default __webpack_public_path__ + "static/media/HettiLogoCircle.77cd386082b4e9f2a16c28c0846427f1.svg";
export { ForwardRef as ReactComponent };